<template lang="pug">
ul.flex.justify-center.border-b.border-gray-650
  li.v-tab-item(
    :data-testid="`v-tab-${index}`"
    v-for="(item, index) in items"
    @click="onClick(item.value)"
    :class="`cursor-pointer font-sans text-center\ px-3 py-1 lg_px-12 md_py-2 \ ${item.value === selected ? 'font-semibold text-black border-b-2 border-black' : 'text-gray-850'} \ `"
  ) {{ item.label }}
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'

const props = defineProps({
  items: {
    type: Array as PropType<{ label: string; value: string }[]>,
    required: false,
    default: () => [{ label: 'Menu Item', value: 'item' }],
  },
})
const selected = ref(null)
const emit = defineEmits(['change'])

onMounted(() => {
  setSelectedTab(props.items)
})

watch(() => props.items, setSelectedTab)

function onClick(value: any) {
  selected.value = value
  emit('change', value)
}

function setSelectedTab(items: any) {
  const selectedItem: any = props.items.filter((item: any) => item.selected)
  selected.value = selectedItem.length ? selectedItem[0].value : props.items[0].value
}
</script>
